import { TValueOf } from 'root-types'

export const FunnelErrorCode = {
  PRIMER_SDK_INIT_FAILED: 'primer.sdk_init_failed',
  STRIPE_3DS_NO_PLAN: 'stripe.3ds_no_plan',
  STRIPE_3DS_NO_CLIENT_SECRET: 'stripe.3ds_no_client_secret',
  FUNNEL_UUID_CREATION_FAILED: 'funnel.uuid_creation_failed',
  FUNNEL_VARIANT_LOAD_FAILED: 'funnel.variant_load_failed',
  FUNNEL_APP_CONFIG_LOAD_FAILED: 'funnel.app_config_load_failed',
  FUNNEL_PAYMENT_CONFIG_LOAD_FAILED: 'funnel.payment_config_load_failed',
  FUNNEL_GROWTHBOOK_INIT_FAILED: 'funnel.growthbook_init_failed',
  FUNNEL_APP_READY_TIMEOUT: 'funnel.app_ready_timeout',
  FUNNEL_STEPS_EMPTY_TIMEOUT: 'funnel.steps_empty_timeout',
  ACCOUNT_LEARNWORLDS_CREATION_FAILED: 'account.learnworlds_creation_failed',
  ACCOUNT_STATUS_MISSING_AFTER_BIND: 'account.status_missing_after_bind',
  PRIMER_SESSION_TOKEN_FAILED: 'primer.session_token_failed',
  PRIMER_SESSION_UPDATE_FAILED: 'primer.session_update_failed',
  STRIPE_NO_PLAN_SELECTED: 'stripe.no_plan_selected',
  STRIPE_WALLET_AVAILABILITY_CHECK_FAILED:
    'stripe.wallet_availability_check_failed',
  FUNNEL_SUBSCRIPTION_LIST_EMPTY: 'funnel.subscription_list_empty',
  FUNNEL_LANGUAGE_LOAD_FAILED: 'funnel.language_load_failed',
} as const

export type TFunnelErrorCode = TValueOf<typeof FunnelErrorCode>

export const FUNNEL_ERROR_TITLES: Record<TFunnelErrorCode, string> = {
  [FunnelErrorCode.PRIMER_SDK_INIT_FAILED]: 'Primer SDK initialization failed',
  [FunnelErrorCode.STRIPE_3DS_NO_PLAN]:
    '3DS check aborted: no subscription plan selected',
  [FunnelErrorCode.STRIPE_3DS_NO_CLIENT_SECRET]:
    '3DS check aborted: no client secret',
  [FunnelErrorCode.FUNNEL_UUID_CREATION_FAILED]: 'User uuid creation failed',
  [FunnelErrorCode.FUNNEL_VARIANT_LOAD_FAILED]: 'Funnel variant failed to load',
  [FunnelErrorCode.FUNNEL_APP_CONFIG_LOAD_FAILED]: 'App config failed to load',
  [FunnelErrorCode.FUNNEL_PAYMENT_CONFIG_LOAD_FAILED]:
    'Payment config failed to load',
  [FunnelErrorCode.FUNNEL_GROWTHBOOK_INIT_FAILED]:
    'GrowthBook initialization failed',
  [FunnelErrorCode.FUNNEL_APP_READY_TIMEOUT]:
    'App stuck on spinner: not ready in time',
  [FunnelErrorCode.FUNNEL_STEPS_EMPTY_TIMEOUT]:
    'App stuck on spinner: no steps resolved',
  [FunnelErrorCode.ACCOUNT_LEARNWORLDS_CREATION_FAILED]:
    'LearnWorlds account creation failed',
  [FunnelErrorCode.ACCOUNT_STATUS_MISSING_AFTER_BIND]:
    'User status missing after account bind',
  [FunnelErrorCode.PRIMER_SESSION_TOKEN_FAILED]:
    'Primer client session token request failed',
  [FunnelErrorCode.PRIMER_SESSION_UPDATE_FAILED]:
    'Primer client session update failed',
  [FunnelErrorCode.STRIPE_NO_PLAN_SELECTED]:
    'Purchase aborted: no subscription plan selected',
  [FunnelErrorCode.STRIPE_WALLET_AVAILABILITY_CHECK_FAILED]:
    'Stripe wallet availability check failed',
  [FunnelErrorCode.FUNNEL_SUBSCRIPTION_LIST_EMPTY]:
    'Paywall rendered with an empty subscription list',
  [FunnelErrorCode.FUNNEL_LANGUAGE_LOAD_FAILED]:
    'Language resources failed to load',
}

export type TFunnelErrorTag = 'payment_system'
